<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="change-pw-view">
    <div class="change-pw-wrap">
      <div class="change-pw-head">
        <div class="icon-ajuntament" />
      </div>
      <h2>{{ $t('change_pw_title') }}</h2>
      <p class="change-pw-desc">{{ $t('change_pw_desc') }}</p>
      <div class="password-wrapp">
        <div class="pass-inputs">
          <div class="input-wrapper">
            <span class="question">{{ $t('new_pw') }}</span>
            <input
              v-model="passwordInput"
              class="change-pw-input"
              :class="arrayErrorInputs.indexOf('password') !== -1 && 'error'"
              type="password"
              :placeholder="$t('password_ex')"
            >
          </div>
          <div class="input-wrapper">
            <span class="question">{{ $t('conf_new_pw') }}</span>
            <input
              v-model="passwordConfInput"
              class="change-pw-input"
              :class="arrayErrorInputs.indexOf('conf-password') !== -1 && 'error'"
              type="password"
              :placeholder="$t('password_ex')"
            >
          </div>
        </div>
        <PasswordHelp :password-input="passwordInput" />
      </div>
      <div class="bottom-wrapper">
        <div v-if="arrayErrorInputs.indexOf('token') !== -1" class="error-token">
          <span>{{ $t('error_token') }}</span>
        </div>
        <div class="button-wrap" @click="changeUserPass">
          <span>{{ $t('confirm') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changePassword } from '@/services/user-api'
import PasswordHelp from '../components/profile/PasswordHelp.vue'
export default {
  components: { PasswordHelp },
  props: {},
  data() {
    return {
      passwordInput: '',
      passwordConfInput: '',
      arrayErrorInputs: [],
      email: '',
    }
  },
  mounted() {
    this.email = this.$route.query.email
  },
  computed: {},
  watch: {
    passwordConfInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('conf-password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('conf-password'), 1)
      }
    },
    passwordInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('password'), 1)
      }
    },
  },
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
    changeUserPass() {
      //check del password
      let regex1 = /[A-Z]/
      let regex2 = /[a-z]/
      let regex3 = /\d/
      if (
        (this.passwordInput.length < 8 ||
          !regex1.test(this.passwordInput) ||
          !regex2.test(this.passwordInput) ||
          !regex3.test(this.passwordInput)) &&
        this.arrayErrorInputs.indexOf('password') === -1
      ) {
        this.arrayErrorInputs.push('password')
      }
      if (
        this.passwordInput !== this.passwordConfInput &&
        this.arrayErrorInputs.indexOf('conf-password') === -1
      ) {
        this.arrayErrorInputs.push('conf-password')
      }
      if (this.arrayErrorInputs.length === 0)
        changePassword(this.$route.query.token, this.email, this.passwordInput).then(resp => {
          if (resp.code === 200) {
            sessionStorage.removeItem('recoverEmail')
            this.routeChange('ConfirmPw')
          }
          if (
            resp.code === 400 &&
            resp.errorDescription === 'Invalid or Expired Token' &&
            this.arrayErrorInputs.indexOf('token') === -1
          ) {
            this.arrayErrorInputs.push('token')
          }
        })
    },
  },
}
</script>

<style lang="stylus" scoped>
.change-pw-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: rgba($bcn-dark-blue-gray, 0.05)

  .change-pw-wrap
    display: flex
    flex-direction: column
    align-items: center
    padding: vw(20px)
    min-width: 250px
    width: 60%
    border-radius: 8px
    background-color: #fff
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
    gap: vw(5px)

    .password-wrapp
      display: flex
      width: 85%

      .pass-inputs
        width: 62%

    .bottom-wrapper
      margin-top: vw(20px)
      width: 50%

      .error-token
        display: flex
        justify-content: center
        width: 100%
        m-font-size(15, 20)
        margin-bottom: vw(25px)
        color: $warning
        font-weight: 600

      span
        m-font-size(12, 20)
        margin-right: vw(4px)

      .button-wrap
        display: flex
        justify-content: center
        margin: vw(5px) 0
        padding: vw(8px) 0
        border-radius: 4px
        background-color: black
        cursor: pointer

        span
          color: white
          m-font-size(14, 20)

    .change-pw-head
      display: flex
      justify-content: space-between
      width: 100%

      .icon-ajuntament
        width: vw(176px)
        height: vw(45px)
        background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
        background-position: center center
        background-size: cover
        background-repeat: no-repeat

    h2
      margin-block-start: 1.5em
      font-size(32, 44)
      font-weight: 600

    .change-pw-desc
      font-size(20, 24)
      display: flex
      justify-content: center
      margin-bottom: vw(20px)
      width: 85%
      font-weight: 400

    .input-wrapper
      display: flex
      flex-direction: column
      margin-bottom: vw(15px)
      width: 85%
      gap: vw(5px)

      .question
        m-font-size(14, 20)
        color: $grey
        font-weight: 400

      .change-pw-input
        m-font-size(16, 20)
        position: relative
        padding: 0
        padding-right: vw(10px)
        padding-left: vw(10px)
        width: 100%
        height: vw(48px)
        outline: none
        border: 1px solid $grey-grey
        border-radius: 4px
        background-color: $light-grey
        color: #000
        font-weight: 600

        &.error
          border: 2px solid $warning
</style>